import React from 'react';
import styled from 'styled-components';
const Wrapper = styled.tbody`
  display: table-row-group;

  tr {
    &:last-of-type {
      th,
      td {
        border-bottom: 0;
      }
    }
  }
`;
export const TableBody = ({
  children,
  ...props
}) => /*#__PURE__*/React.createElement(Wrapper, props, children);
export default TableBody;
//# sourceMappingURL=index.js.map